"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RECONCILIATIONS_STATUSES = void 0;
var RECONCILIATIONS_STATUSES = exports.RECONCILIATIONS_STATUSES = ['PENDING', 'AUTO_RECONCILED', 'MANUALLY_RECONCILED', 'AUTO_PERSONAL', 'MANUALLY_PERSONAL', 'SKIP'];